import Button from 'components/Form/Button';
import React, { useEffect, useState } from 'react';
import Bond from '../../../../../../assets/assets/bonds.png';
import { Bonds } from 'service/dto/bond.dto';
import ConfirmModal from 'components/Modal/ConfirmModal';
import withCreatePortal from 'components/HOC/withCreatePortal';
import { useRemoveBondTrustee } from 'common/queries-and-mutations/bond';
import { toast } from 'react-toastify';
import { Alert } from 'components/Toast';

type Props = {
  assets: Bonds;
  trusteeId: number;
  onSuccess: () => void;
};

const EnhancedConfirmModal = withCreatePortal(ConfirmModal);

export default function BondsAssets({ assets, trusteeId, onSuccess }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAskToConfirm, setShowAskToConfirm] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(null);

  const { mutate, isSuccess, isError } = useRemoveBondTrustee();

  const handleDelete = () => {
    mutate({ assetId: selectedAssetId!, trusteeId });
  };

  useEffect(() => {
    if (isSuccess && !isError) {
      setShowAskToConfirm(false);
      setIsSubmitting(false);
      setSelectedAssetId(null);
      onSuccess();
      toast(<Alert message="Asset Successfully Removed" type="success" />);
    } else if (isError) {
      setIsSubmitting(false);
    }
  }, [isError, isSuccess]);

  return (
    <div>
      {assets?.map(asset => {
        return (
          <div className="mt-2 flex flex-col" key={asset.id}>
            <div className="w-full rounded-md bg-white shadow-sm">
              <div className="border-b border-[#E5E5E5]">
                <div className="flex items-center justify-between p-3 px-5">
                  <span className="text-base font-normal text-[#34475E]">
                    Bonds
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap items-center justify-between px-4 pb-1">
                <div className="mr-3 space-y-2">
                  <img src={Bond} className="h-[6rem] w-[9rem]" />
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Company Name
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.issuerName}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    ISIN Number
                  </div>
                  <div className="text-xs text-slate-600 ">{asset.ISINNo}</div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Currency
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.currency}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Maturity Date
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.maturityDate}
                  </div>
                </div>
                <div className="mr-3 space-y-2">
                  <Button
                    variant="outline"
                    size="md"
                    className="w-[8rem] place-self-end rounded border border-[#FF6600] bg-[#FF66001A] text-sm text-[#FF6600] lg:ml-8"
                    label="Remove"
                    onClick={() => {
                      setShowAskToConfirm(true);
                      setSelectedAssetId(asset.id);
                    }}
                  ></Button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {showAskToConfirm && selectedAssetId && (
        <EnhancedConfirmModal
          content="Are you sure you want to remove this asset?"
          onConfirm={() => {
            setIsSubmitting(true);
            handleDelete();
          }}
          onCancel={() => {
            setShowAskToConfirm(false);
          }}
          actionText="Yes, Remove"
          cancelText="No"
          title="Action Required"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
}
